export function lowBrowser() {
    let browserLevel = 'normal',
        updateDom,
        htmlDom;
    if (!!document.querySelectorAll && !!document.querySelector) {
        updateDom = document.querySelectorAll('.yq-brower-update');
        htmlDom = document.querySelector('html');

        if (updateDom.length < 1) {
            browserLevel = 'normal';
        } else {
            if (hasClass(htmlDom, 'csscalc')) {
                browserLevel = 'low-csscalc';
            } else if (hasClass(htmlDom, 'no-csscalc')) {
                browserLevel = 'low-no-csscalc';
            } else {
                browserLevel = 'low';
            }
        }
    } else {
        browserLevel = 'low';
    }

    return browserLevel;
}

function hasClass(el, className) {
    var hasClass;
    if (el.classList) {
        hasClass = el.classList.contains(className);
    } else {
        hasClass = new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
    }
    return hasClass;
}

export function createGUID(tpl, regexp) {
    const time = new Date().getTime();
    return (tpl || 'G-xxxxxxxxxxxxxxxx').replace((regexp || /[xy]/g), function (r) {
        const random = (time + Math.random() * 16) % 16 | 0;
        // d = Math.floor(time / 16);
        return ((r === 'x' ? random : (random & 7 | 8)).toString(16)).toUpperCase();
    });
}